import { Grid } from '@mui/material';
import Skeleton from 'Theme/components/Skeleton';
import useTranslate from './useTranslate';
import { TableCollectionColumn } from 'Components/Shared/Table';
import UserStatusChip from 'Components/Shared/Chips/UserStatusChip/UserStatusChip';
import { PersonAvatar } from 'Theme/components/Avatar';
import { userFullName } from 'Tools';
import { displayDefaultColor } from 'Tools/displayDefaultColor';

function toLightPersonProfile(
  person: IOrganizationGuestPerson
): ILightPersonProfile {
  return { ...person };
}

// Guest individuals are not part of the current account, so their name is not clickable.
function GuestUserNameCell({ person }: Readonly<{ person: ILightPersonProfile }>) {
  const isDisabled = displayDefaultColor(person);
  return (
    <Grid container alignItems="center" wrap="nowrap">
      <PersonAvatar component="span" person={person} size="smaller" isDisabled={isDisabled} />
      <span style={{ marginLeft: '16px' }}>
        {userFullName(person.lastName, person.firstName)}
      </span>
    </Grid>
  );
}

export const useColumnsOrganizationGuestUsers = (): TableCollectionColumn<{
  node: IOrganizationGuestPerson;
}>[] => {
  const ts = useTranslate();

  return [
    {
      key: 'user',
      renderHead: () => ts('page.users.index.users'),
      renderSkeleton: () => (
        <Grid container={true} alignItems="center">
          <Skeleton variant="circle" width={24} height={24} />
          <Skeleton
            variant="rectangular"
            width="20%"
            style={{ marginLeft: '16px' }}
          />
        </Grid>
      ),
      renderCell: ({
        row: { node: person }
      }: {
        row: { node: IOrganizationGuestPerson };
      }) => <GuestUserNameCell person={toLightPersonProfile(person)} />
    },
    {
      key: 'email',
      renderHead: () => ts('page.users.index.email'),
      renderSkeleton: () => <Skeleton variant="rectangular" width="80%" />,
      renderCell: ({
        row: { node: person }
      }: {
        row: { node: IOrganizationGuestPerson };
      }) => person.email
    },
    {
      key: 'status',
      renderHead: () => ts('page.users.index.allStatus'),
      renderSkeleton: () => <Skeleton variant="rectangular" width="10%" />,
      renderCell: ({
        row: { node: person }
      }: {
        row: { node: IOrganizationGuestPerson };
      }) => (
        <UserStatusChip person={toLightPersonProfile(person) as IPerson} />
      )
    }
  ];
};
